export class LaudosPdfModel {
  id_laudo: number;
  id_mercadoria: number = null;
  id_terminal: number = null;
  id_status: number = 1;
  id_cliente: number = null;
  id_unidade: number = null;
  id_fatura: number = null;
  data: string;
  valor: string;
  container: string;
  conhecimento: string;
  fatura: string;
  referencia: string;
  numero: string;
}



// WEBPACK FOOTER //
// ./src/app/laudos-pdf/laudos-pdf.model.ts